<template>
     <ul class="cooperation" id="cooperate">
        <li v-for="(item,index) of list" :key="index">
            <img :src="item" alt="" :id="index===0?'business':''">
        </li>
    </ul>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import {cooperation} from '@/common/util/data.js'
export default {
    name:'cooperation',
    metaInfo:metaInfo.Cooperation,
    data(){
        return {
            ...cooperation
        }
    }
    
}
</script>
<style lang="less" scoped>
.cooperation{
  margin-bottom: 120px;
    li{
        img{
            width:100%;
            height:auto
        }
    }
}
</style>